export enum BulkUploadStatus {
  fails = 'fails',
  completeWithErrors = 'completeWithErrors',
  complete = 'complete',
  canceled = 'canceled',
  processing = 'processing',
  waitingForConfirmation = 'waitingForConfirmation',
}
